/*=========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
==========================================================================================*/


import state from './moduleTraineeCoachAssignmentState.js'
import mutations from './moduleTraineeCoachAssignmentMutations.js'
import actions from './moduleTraineeCoachAssignmentActions.js'
import getters from './moduleTraineeCoachAssignmentGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

